import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import router, { ROUTE_NAME_MAINTENANCE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'SystemWide',
        key: 'Maintenance',
        name: 'Maintenance',
        icon: 'fas fa-procedures',
        route: { name: ROUTE_NAME_MAINTENANCE },
        roles: [Role.SUPER_USER]
    }
]);

export default registerRouteForModule(router);
